import React, { Component, Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import FleetManagerService from '../../../services/FleetManagerService';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';

class FleetVehicleDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fleetData: [],
      isLoading: false
    };
  }

  componentDidMount() {
    this.getFleetVehicleData();
  }

  getFleetVehicleData = async () => {
    let { fleetData, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await FleetManagerService.getFleetVehicleData(this.props.fleet.uuid);
      isLoading = false;
      this.setState({ isLoading });
      if (data && data.data) {
        fleetData = data.data;
      }

      this.setState({ fleetData });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
      console.log(error);
    }
  }

  onCancelClick = () => {
    swal.close();
  }

  render() {
    const { fleetData, isLoading } = this.state;
    return (
      <div>
        {isLoading && <CustomSpinner />}
        <Row>
          <Col xl="10" md="10" sm="10" xs="10" className="fleet-detail-vehicle-details-of-fleet">
            Vehicle Details of {this.props.fleet && this.props.fleet.owner_name}, <span style={{ textTransform: 'lowercase' }}>{this.props.fleet.member_id && this.props.fleet.member_id}</span>
          </Col>
          <Col>
            <FontAwesomeIcon className="pull-right" onClick={this.onCancelClick} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
          </Col>
        </Row>

        <Row>
          <Col>
            {
              (fleetData || []).map((fleet, i) => (
                <Row key={fleet.type}>
                  <Col>
                    <Row style={{ opacity: '0.8', backgroundColor: '#fdbb1f', height: '50px', marginTop: '15px', marginLeft: '0px', marginRight: '0px' }}>
                      <Col xl="2" md="2" sm="2" xs="2">
                        <img src={fleet.type_image_url} alt={fleet.type} style={(fleet.type || '').toLowerCase() === 'lcv' ? { width: '56px', objectFit: 'contain', marginTop: '4px' } : { width: '70px', objectFit: 'contain', marginTop: '4px' }} />
                      </Col>

                      <Col xl="4" md="4" sm="4" xs="4" className="fleet-details-truck-bus" style={{ marginLeft: '0px' }}>
                        <div style={{ marginTop: '17px' }}>{fleet.type}</div>
                      </Col>
                      <Col xl="5" md="5" sm="5" xs="5" className="fleet-details-truck-bus" style={{ marginLeft: '0px' }}>
                        <div style={{ marginTop: '17px' }}>
                          Count: <b>{fleet.total_vehical}</b>
                        </div>
                      </Col>

                    </Row>
                    {
                      (fleet.data || []).length > 0 &&
                      <div className="fleet-details-main-div">

                        <Row>
                          <Col>
                            {
                              (fleet.data || []).map((d, index) => (
                                <Fragment key={d.fleet_id}>
                                  <Row style={{ marginTop: '15px' }}>
                                    <Col xl="2" md="2" sm="3" xs="3" />
                                    <Col xl="4" md="4" sm="4" xs="4" className="fleet-reg-title">
                                      Make
                                  </Col>
                                    <Col xl="5" md="5" sm="5" xs="5" className="fleet-reg-title">
                                      Tyre Count: <b>{d.fleet_total_tyre}</b>
                                    </Col>
                                  </Row>

                                  <Row className="margin-top-15">
                                    <Col xl="2" md="2" sm="2" xs="2">
                                      <img src={d.brand_image_url || '/images/no-image-available.jpg'} alt={d.brand_name} className="fleet-reg-image" style={{ marginLeft: '15px' }} />
                                    </Col>
                                    <Col xl="4" md="4" sm="4" xs="4" title={d.brand_name} className="make-data text-overflow-dots">
                                      {d.brand_name}
                                    </Col>
                                    <Col xl="5" md="5" sm="5" xs="5" className="fm-detail-count">
                                      {
                                        d.number_of_tyres_vehicle_count['4_wheeler'] > 0 && <div>
                                          <span >4 Wheeler - <b>{d.number_of_tyres_vehicle_count['4_wheeler']}</b></span>
                                        </div>
                                      }
                                      {
                                        d.number_of_tyres_vehicle_count['6_wheeler'] > 0 && <div>
                                          <span >6 Wheeler - <b>{d.number_of_tyres_vehicle_count['6_wheeler']}</b></span>
                                        </div>
                                      }

                                      {
                                        d.number_of_tyres_vehicle_count['10_wheeler'] > 0 && <div>
                                          <span >10 Wheeler - <b>{d.number_of_tyres_vehicle_count['10_wheeler']}</b></span>
                                        </div>
                                      }

                                      {
                                        d.number_of_tyres_vehicle_count['12_wheeler'] > 0 && <div>
                                          <span >12 Wheeler - <b>{d.number_of_tyres_vehicle_count['12_wheeler']}</b></span>
                                        </div>
                                      }

                                      {
                                        d.number_of_tyres_vehicle_count['14_wheeler'] > 0 && <div>
                                          <span >14 Wheeler - <b>{d.number_of_tyres_vehicle_count['14_wheeler']}</b></span>
                                        </div>
                                      }

                                      {
                                        d.number_of_tyres_vehicle_count['16_wheeler'] > 0 && <div>
                                          <span >16 Wheeler - <b>{d.number_of_tyres_vehicle_count['16_wheeler']}</b></span>
                                        </div>
                                      }

                                      {
                                        d.number_of_tyres_vehicle_count['18_wheeler'] > 0 && <div>
                                          <span >18 Wheeler - <b>{d.number_of_tyres_vehicle_count['18_wheeler']}</b></span>
                                        </div>
                                      }

                                      {
                                        d.number_of_tyres_vehicle_count['22_wheeler'] > 0 && <div>
                                          <span >22 Wheeler - <b>{d.number_of_tyres_vehicle_count['22_wheeler']}</b></span>
                                        </div>
                                      }

                                      {
                                        d.number_of_tyres_vehicle_count['28_wheeler'] > 0 && <div>
                                          <span >28 Wheeler - <b>{d.number_of_tyres_vehicle_count['28_wheeler']}</b></span>
                                        </div>
                                      }
                                    </Col>
                                  </Row>

                                  {
                                    fleet.data && fleet.data.length !== index + 1 &&
                                    <hr />
                                  }
                                </Fragment>
                              ))
                            }
                          </Col>
                        </Row>
                      </div>}
                  </Col>
                </Row>
              ))
            }
          </Col>
        </Row>

      </div >
    );
  }
}

export default FleetVehicleDetails;

